import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import { useStyles } from "./InvestorLayout.styles";
import { ToastContainer } from "react-toastify";
import {
  IconBrowser,
  IconHome,
  IconSignature,
  IconCoin,
} from "@tabler/icons-react";
import NavBar from "../../components/NavBar/NavBar";
import { RootState } from "../../store";

interface IProps {
  content: ReactNode;
}

const InvestorLayout: FC<IProps> = ({ content }) => {
  const isAuthRep = useSelector((state: RootState) => state.auth.isAuthRep); // Access isAuthRep specifically
  const { classes } = useStyles();
  const entityType = useSelector((state: RootState) => state.auth.entityType);
  const token = useSelector((state: RootState) => state.auth.token);
  const isIndividual = entityType === "individual";

  const mainMenus = [
    {
      label: "Dashboard",
      path: "/investor-dashboard/investordashboard",
      icon: <IconHome />,
    },
    {
      label: "Offer Room",
      submenu: [
        { label: "View Offer Room", path: "/note-offer-room" },
        {
          label: "Subscribed/Invested Notes",
          path: "/subscribed-invested-notes",
        },
      ],
      icon: <IconBrowser />,
    },
    ...(isAuthRep || isIndividual
      ? [
          {
            label: "Withdrawal",
            path: "/withdrawal",
            icon: <IconCoin />,
          },
        ]
      : []),
    {
      label: "Signed Documents",
      path: "/investor-signed-documents",
      icon: <IconSignature />,
    },
  ];

  return (
    <div className={classes.mainContainer}>
      <NavBar menus={mainMenus} />
      <ToastContainer />
      <div className={classes.hero}>{content}</div>
    </div>
  );
};

export default InvestorLayout;
